import { Actions } from '../../actions/index';
import { PersistentReportFilterState } from '@mode/legacy/types-app-state';
import { ReportTypes } from '@mode/shared/contract-common';
import { ImmutableRecordSet } from '@mode/legacy/types-app-state';
import { reportFilterActions } from '@mode/report-viewer/domain';

export const initialPersistentReportFilterState: PersistentReportFilterState =
  new ImmutableRecordSet<ReportTypes.ReportFilterResource>('token');

function reportFilterReducer(state = initialPersistentReportFilterState, action: Actions): PersistentReportFilterState {
  switch (action.type) {
    case reportFilterActions.loadReportFiltersSuccess.type:
      return state.mergeRecords(action.resources);
    case reportFilterActions.createReportFilterSuccess.type:
      return state.mergeRecords([action.resource]);
    case reportFilterActions.destroyReportFilterSuccess.type:
      return state.removeRecordByKey(action.token);
    case reportFilterActions.updateReportFilterSuccess.type:
      return state.mergeRecords([action.resource]);
    case reportFilterActions.updateReportFilterDefaultsSuccess.type:
      return state.mergeRecords(action.resources);
  }

  return state;
}

export const PersistentReportFilterReducer = reportFilterReducer;
